var $3ef905a2ce0921cb$exports = {};
$3ef905a2ce0921cb$exports = {
    "(optional)": `(opcion\xe1lis)`,
    "(required)": `(k\xf6telez\u{151})`
};


export {$3ef905a2ce0921cb$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
